module.exports = __webpack_public_path__ + "static/media/tab-contact.ab74dfa1.jpg";